import { Link } from 'react-router-dom';

import { styled, typography } from '@pulse-web-ui/theme';

export const Hint = styled.p`
  ${typography.regular14}
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 20px;
`;

export const AuthLink = styled(Link)`
  color: ${({ theme }) => theme.colors.text.interactive};
  text-decoration: none;
`;
